import type { MemoryBankNote } from '@erp/rpc';

export function useNoteActor(versionUsed: number, note?: MemoryBankNote) {
  const actor = note?.editLog[versionUsed]?.actor;

  if (!actor) {
    return null;
  }

  let actorStr = 'by ';

  if (actor.type === 'user') {
    actorStr += actor.userName;
    actorStr += actor.systemComponent ? ` with GentlyAI` : '';
  } else if (actor.type === 'system') {
    actorStr += 'GentlyAI';
    actorStr += actor.userName ? ` with ${actor.userName}` : '';
  }

  return actorStr;
}
